import React, { Component} from 'react'
import { Redirect } from "react-router-dom";

import { createObject } from "../../api";


export class MediaCreate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: true,
            pid: null
        }
    }

    componentDidMount() {
        createObject('media').then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({pid: data._id});
            }           
        });
    }

    render() {
        if (!this.state.pid) { return null; }
            
        return <Redirect to={`/admin/media/edit?pid=${this.state.pid}`} />  
    }
}
export default MediaCreate


